export class Menu {
  constructor(
    id,
    label,
    icon,
    iconHover,
    href,
    isRedirect,
    isDofollow,
    subMenu,
    isCustom,
    isComingSoon,
    requireLogin,
    onClick,
    className,
    hide,
    closeMenu,
    country,
    lang,
  ) {
    this.id = id;
    this.label = label;
    this.icon = icon;
    this.iconHover = iconHover;
    this.href = href;
    this.isRedirect = isRedirect;
    this.isDofollow = isDofollow;
    this.subMenu = subMenu;
    this.isCustom = isCustom;
    this.isComingSoon = isComingSoon;
    this.requireLogin = requireLogin;
    this.onClick = onClick;
    this.className = className;
    this.hide = hide;
    this.closeMenu = closeMenu;
    this.country = country;
    this.lang = lang;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Menu(
        input.id,
        input.label,
        input.icon,
        input.iconHover,
        input.href,
        input.isRedirect,
        input.isDofollow,
        Menu.fromApiArray(input.subMenu),
        input.isCustom,
        input.isComingSoon,
        input.requireLogin,
        input.onClick,
        input.className,
        input.hide,
        input.closeMenu,
        input.country,
        input.lang,
      );
    }

    return new Menu();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Menu.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Menu.fromApiObject(input)];
    }

    return [];
  }
}